import { useEffect } from "react";

const SITE_URL = "https://www.buscavidapizzeria.it";

const setMeta = (attribute, key, content) => {
    let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
    if (!element) {
        element = document.createElement("meta");
        element.setAttribute(attribute, key);
        document.head.appendChild(element);
    }
    element.setAttribute("content", content);
};

export default function Seo({ title, description, path = "/", noIndex = false }) {
    useEffect(() => {
        const canonicalUrl = `${SITE_URL}${path}`;
        const image = `${SITE_URL}/logo512.png`;
        document.title = title;

        setMeta("name", "description", description);
        setMeta("name", "robots", noIndex ? "noindex, nofollow" : "index, follow, max-image-preview:large");
        setMeta("property", "og:type", "website");
        setMeta("property", "og:locale", "it_IT");
        setMeta("property", "og:site_name", "Busca Vida Pizzeria");
        setMeta("property", "og:title", title);
        setMeta("property", "og:description", description);
        setMeta("property", "og:url", canonicalUrl);
        setMeta("property", "og:image", image);
        setMeta("name", "twitter:card", "summary_large_image");
        setMeta("name", "twitter:title", title);
        setMeta("name", "twitter:description", description);
        setMeta("name", "twitter:image", image);

        let canonical = document.head.querySelector('link[rel="canonical"]');
        if (!canonical) {
            canonical = document.createElement("link");
            canonical.rel = "canonical";
            document.head.appendChild(canonical);
        }
        canonical.href = canonicalUrl;
    }, [description, noIndex, path, title]);

    return null;
}

